import Joi from "joi";

import {constantsRegex} from "../constants/constants.regex";

export const registrationCleanerStep1Validator = Joi.object({
  last_name: Joi.string().required().messages({
    'string.empty': 'Заповніть це поле',
    'any.required': 'Заповніть це поле',
  }),
  first_name: Joi.string().required().messages({
    'string.empty': 'Заповніть це поле',
    'any.required': 'Заповніть це поле',
  }),
  password: Joi.string().required().min(8).messages({
    'string.empty': 'Заповніть це поле',
    'string.min': 'Не менше 8 символів',
    'any.required': 'Заповніть це поле',
  }),
  confirm_password: Joi.string().required().min(8).valid(Joi.ref('password')).messages({
    'string.empty': 'Заповніть це поле',
    'string.min': 'Не менше 8 символів',
    'any.only': 'Паролі не збігаються',
    'any.required': 'Заповніть це поле',
  }),
  email: Joi.string().pattern(constantsRegex.EMAIL).required().messages({
    'string.empty': 'Заповніть це поле',
    'string.pattern.base': 'Невалідний email',
    'any.required': 'Заповніть це поле',
  }),
  taxpayer_number: Joi.string().required().min(10).max(10).messages({
    'string.empty': 'Заповніть це поле',
    'string.pattern.base': 'Поле повинно містити тільки цифри',
    'string.min': 'Поле повинно містити щонайменше 10 символів',
    'string.max': 'Невалідний ІПН',
    'any.required': 'Заповніть це поле',
  }),
  mobile_nummer: Joi.string().required().messages({
    'string.empty': 'Заповніть це поле',
    'any.required': 'Заповніть це поле',
  }),
  credit_cart_number: Joi.string().required().min(19).length(19).messages({
    'string.empty': 'Заповніть це поле',
    'string.length': 'Неправильний номер карти',
    'string.min': 'Неправильний номер карти',
    'any.required': 'Заповніть це поле',
  }),
  invited_by: Joi.string().optional().allow("").messages({
  }),
});
